import React, {useEffect, useRef, useState} from 'react';
import './DefaultSettingsSidebarContentPrompt.css'
import {useDispatch, useSelector} from "react-redux";
import {getProjectDefaultPrompt, saveProjectDefaultPrompt} from "../../reducers/user";
import {getGlobalState} from "../../globals";
import PromptPlaceholder from "./PromptPlaceholder";

const DefaultSettingsSidebarContentPrompt = ({}) => {
    const siteId = getGlobalState('site_id');

    const dispatch = useDispatch();

    const defaultPrompt = useSelector(getProjectDefaultPrompt)

    const [text, setText] = useState(defaultPrompt);
    const [saveTimeout, setSaveTimeout] = useState(null);
    const [showSaved, setShowSaved] = useState(!!text);
    const [showError, setShowError] = useState(false);

    const promptTextArea = useRef(null);

    const textareaOnChange = (e) => {
        const value = e.target.value;

        setText(value);
        setShowSaved(false);
        setShowError(false);
        updateTextareaHeight(e.target);


        // Clear the previous timer
        if (saveTimeout) {
            clearTimeout(saveTimeout);
        }

        if(text.length > 1000) {
            return setShowError(true)
        }

        // Start a new timer
        const newTimeout = setTimeout(() => {
            dispatch(saveProjectDefaultPrompt(siteId, value))
            setShowSaved(true)
        }, 1000); // 1 second

        // Save the new timer
        setSaveTimeout(newTimeout);
    };

    const updateTextareaHeight = (element) => {
        element.style.height = '0';
        element.style.height = `${element.scrollHeight + 4}px`;
    };

    const showSavedLabel = () => showError ? 'Text too long' : showSaved ? 'Saved!' : '';


    return (
        <>
            <div className="default-settings-textarea__wrapper">
                <label htmlFor="defaultPrompt">Campaign brief <span className={`${showError ? 'has-error' : ''}`}>{showSavedLabel()}</span></label>
                <textarea
                    name="defaultPrompt"
                    id="defaultPrompt"
                    placeholder=""
                    ref={promptTextArea}
                    value={text}
                    onChange={textareaOnChange}
                    style={{ overflowY: 'hidden' }}
                    rows={1}
                />
                {!text.length && <PromptPlaceholder />}
                {!!text && <span className={`prompt__counter ${text.length > 1000 ? 'exceed' : ''}`}>{text.length}/1000</span>}
            </div>
            <div className="default-settings-info">This brief will be prompted in the AI content generation process for all articles generated in this campaign.</div>
        </>
    );
};

export default DefaultSettingsSidebarContentPrompt